import styled from 'styled-components'
import { colors } from 'const/colors'
import Icon from 'ui/atoms/Icon'
import { Body, H1 } from 'syf-component-library/ui/typography'
import { Inset } from 'syf-component-library/ui/spacing'

export const Container = styled(Inset)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  height: 100%;
  text-align: center;
`

export const HeaderText = styled(H1)`
  font-size: 24px;
`

export const Text = styled(Body)`
  color: ${colors.darkGrey};
`

export const IconSection = styled.div`
  display: flex;
  justify-content: center;
`

const MaintenanceAlert = ({ message }: { message: string }) => {
  return (
    <Container role="alert" aria-live="assertive">
      <HeaderText>We&apos;re Sorry</HeaderText>
      <Text>{message}</Text>
      <IconSection>
        <Icon name="falTools" size="64px" />
      </IconSection>
    </Container>
  )
}

export default MaintenanceAlert
